import { getFyNumber } from '../../utils/calculation';

export const returnCrpLabel = (crp: string) =>
  `${crp} - FY${getFyNumber(crp) + 2}`;

export const returnPillLabel = (selectedValues: string[]) => {
  if (selectedValues.includes('all')) return 'All CRP Plans';
  if (selectedValues.includes('noCrp')) return 'All projects';
  if (selectedValues.length > 2)
    return (
      selectedValues
        .slice(0, 2)
        .map((value) => returnCrpLabel(value))
        .join(', ') +
      ' + ' +
      (selectedValues.length - 2)
    );
  return selectedValues.map((value) => returnCrpLabel(value)).join(', ');
};
